import React from 'react'

import { cn } from '@app/utils'

import { Flag } from '../Flag'

type Props = {
  label: string
  primary: React.ReactNode
  className?: string
  flag?: React.ComponentProps<typeof Flag>
  icon?: React.ReactNode
  mode?: 'warning' | 'success'
}

export function KPICard(props: Props) {
  const { label, primary, className, flag, icon, mode } = props

  return (
    <div
      className={cn(
        'flex items-center gap-xs rounded-lg border p-md',
        {
          'border-gray-400': mode === undefined,
          'border-red-300 bg-red-100 text-red-800': mode && mode === 'warning',
          'border-green-300 bg-green-100 text-green-800': mode === 'success',
        },
        className,
      )}
    >
      {icon ? icon : null}
      <div>
        <div className="flex flex-wrap items-center gap-2xs">
          <span className="text-[24px] font-bold">{primary}</span>
          {flag ? <Flag {...flag} /> : null}
        </div>
        <p className="text-sm">{label}</p>
      </div>
    </div>
  )
}
